export const maxWidth = 1280;

export const padding = 40;

export const compactPadding = 20;
